// THIẾT LẬP NHANH (16/10/2026) — chỉnh NGOÀI sơ đồ những thứ người dùng hay đổi nhất, không phải vào từng bước (lỗi người dùng báo 16/10: "chọn sản phẩm khác nhưng sơ đồ
// vẫn là của sản phẩm cũ, phải vào trong chỉnh từng bước"; "comment có chèn ảnh + link nhưng đăng ra chỉ có chữ; nên thêm câu hook"):
//  · TỪ KHOÁ tìm bài / chọn nhóm (tham số của các bước) — sửa một chỗ, áp mọi bước dùng từ khoá đó;
//  · KÈM ẢNH sản phẩm cho mọi bước bình luận / trả lời / đăng bài hỗ trợ (src/shared/kem-anh.ts);
//  · CÂU HOOK + LIÊN KẾT quảng bá: ghi thành hai dòng cuối của Giọng điệu (mọi bước soạn chữ đều đọc Giọng điệu) — TẤT ĐỊNH, đọc ngược được (như kinh-nghiem-loc.ts);
//  · ĐỔI SẢN PHẨM kéo theo mọi chỗ nhắc tên cũ: Mong muốn, "AI đã tự giả định", giọng điệu, mục tiêu, cấm kỵ, từ khoá.
// Hàm thuần — trang web và máy chủ dùng chung; test ở tests/unit/thiet-lap-nhanh.test.ts.
import { THAO_TAC_DANG_KEM_ANH, THAO_TAC_KEM_ANH, TI_LE_ANH_MAC_DINH, type CheDoKemAnh } from "./kem-anh";
import { doiTenSanPhamTrongSoDo } from "./goi-seeding";
import { GIOI_HAN_SO_DO, type SoDo } from "./so-do";

type Nut = { id: string; thaoTac: string; thamSo?: Record<string, string>; nenTang?: string };
const dsNut = (sd: SoDo): Nut[] => (Array.isArray(sd?.nut) ? (sd.nut as unknown as Nut[]) : []);

import { DAU_HOOK, DAU_LIEN_KET, docLoiVanNhanh, ghiLoiVanNhanh, gopLienKet, HOOK_TOI_DA, kiemLoiVanNhanh, LIEN_KET_TOI_DA, tachLienKet, type LoiVanNhanh } from "./hook-lien-ket";
export { DAU_HOOK, DAU_LIEN_KET, docLoiVanNhanh, ghiLoiVanNhanh, gopLienKet, HOOK_TOI_DA, kiemLoiVanNhanh, LIEN_KET_TOI_DA, tachLienKet, type LoiVanNhanh };

// ---------------------------------------------------------------------------------------------------------------------------------------
// Kèm ảnh sản phẩm
/** Bước hỗ trợ kèm ảnh (bình luận / trả lời / đăng bài) theo mạng của bước. */
export function nutKemAnh(sd: SoDo): Nut[] {
  return dsNut(sd).filter((n) => {
    const mang = n.nenTang ?? sd.nenTang;
    return !!THAO_TAC_KEM_ANH[mang]?.includes(n.thaoTac) || !!THAO_TAC_DANG_KEM_ANH[mang]?.includes(n.thaoTac);
  });
}

export interface KemAnhNhanh {
  soBuoc: number; cheDo: CheDoKemAnh; tiLe: number;
  /** Tập ảnh (anh_chon, src/shared/kho-anh.ts) của bước ĐANG BẬT kèm ảnh đầu tiên; "" = không chọn (bot lấy ảnh sản phẩm như trước). */
  anhChon: string;
  /** Mọi bước đang bật kèm ảnh dùng CÙNG tập ảnh? false = các bước đặt tập khác nhau trong sơ đồ (thẻ không ghi đè nếu người dùng không đụng tới ô ảnh). */
  dongNhatAnh: boolean;
}
/** Chế độ hiện tại: lấy từ bước hỗ trợ đầu tiên; không có bước nào bật → "khong". */
export function docKemAnh(sd: SoDo): KemAnhNhanh {
  const ds = nutKemAnh(sd);
  const dangBat = ds.filter((n) => n.thamSo?.kem_anh === "luon" || n.thamSo?.kem_anh === "ti_le");
  const bat = dangBat[0];
  const tl = Number(bat?.thamSo?.ti_le_anh);
  const anhCua = (n: Nut): string => (typeof n.thamSo?.anh_chon === "string" ? n.thamSo.anh_chon.trim() : "");
  return {
    soBuoc: ds.length, cheDo: bat ? (bat.thamSo!.kem_anh as CheDoKemAnh) : "khong", tiLe: Number.isFinite(tl) && tl >= 1 && tl <= 100 ? Math.round(tl) : TI_LE_ANH_MAC_DINH,
    anhChon: bat ? anhCua(bat) : "", dongNhatAnh: dangBat.every((n) => anhCua(n) === anhCua(bat!)),
  };
}

/**
 * Đặt chế độ kèm ảnh cho MỌI bước hỗ trợ. "khong" → gỡ khoá (bản dịch y như chưa từng bật).
 * `anhChon` (17/10/2026, chọn tập ảnh NGAY ở thẻ): undefined = KHÔNG đụng anh_chon của từng bước (như trước, giữ tập riêng đặt trong sơ đồ);
 * chuỗi = ghi cho MỌI bước hỗ trợ khi chế độ ≠ "khong"; "" hoặc chế độ "khong" → gỡ khoá anh_chon (bản dịch y như chưa chọn ảnh). Không sửa đầu vào.
 */
export function datKemAnh(sd: SoDo, cheDo: CheDoKemAnh, tiLe?: number, anhChon?: string): SoDo {
  const ids = new Set(nutKemAnh(sd).map((n) => n.id));
  const tap = typeof anhChon === "string" ? anhChon.trim() : undefined;
  const nut = dsNut(sd).map((n) => {
    if (!ids.has(n.id)) return n;
    const ts = { ...(n.thamSo ?? {}) };
    delete ts.kem_anh; delete ts.ti_le_anh;
    if (cheDo !== "khong") ts.kem_anh = cheDo;
    if (cheDo === "ti_le") ts.ti_le_anh = String(Math.min(100, Math.max(1, Math.round(tiLe ?? TI_LE_ANH_MAC_DINH))));
    if (tap !== undefined) { if (cheDo === "khong" || tap === "") delete ts.anh_chon; else ts.anh_chon = tap; }
    return { ...n, thamSo: ts };
  });
  return { ...sd, nut } as unknown as SoDo;
}

// ---------------------------------------------------------------------------------------------------------------------------------------
// Từ khoá
const NHAN_TU_KHOA: Readonly<Record<string, string>> = { tu_khoa: "Từ khoá tìm bài / video", tu_khoa_chon_nhom: "Từ khoá chọn nhóm" };
export interface OTuKhoa { ten: string; nhan: string; giaTri: string; soBuoc: number }
/** Mỗi cặp (tham số từ khoá, giá trị hiện tại) = một ô; nhiều bước cùng từ khoá gộp một ô. */
export function docTuKhoa(sd: SoDo): OTuKhoa[] {
  const ra = new Map<string, OTuKhoa>();
  for (const n of dsNut(sd)) {
    for (const ten of Object.keys(NHAN_TU_KHOA)) {
      const v = n.thamSo?.[ten];
      if (typeof v !== "string" || !v.trim()) continue;
      const k = `${ten}\u0000${v}`;
      const co = ra.get(k);
      if (co) co.soBuoc++; else ra.set(k, { ten, nhan: NHAN_TU_KHOA[ten]!, giaTri: v, soBuoc: 1 });
    }
  }
  return [...ra.values()];
}
/** Đổi từ khoá `cu` của tham số `ten` thành `moi` ở MỌI bước đang có đúng giá trị đó. */
export function datTuKhoa(sd: SoDo, ten: string, cu: string, moi: string): SoDo {
  const nut = dsNut(sd).map((n) => (n.thamSo?.[ten] === cu ? { ...n, thamSo: { ...n.thamSo, [ten]: moi } } : n));
  return { ...sd, nut } as unknown as SoDo;
}

// ---------------------------------------------------------------------------------------------------------------------------------------
// Đổi sản phẩm → thay tên cũ ở MỌI chỗ
const thayTen = (s: string, cu: string, moi: string): string => s.split(moi).map((d) => d.split(cu).join(moi)).join(moi);
const thayKhongHoa = (s: string, cu: string, moi: string): string => {
  const re = new RegExp(cu.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
  return s.replace(re, (m) => (m === moi ? m : moi));
};

/** Tên NGẮN của sản phẩm: phần trước dấu phân cách " — ", " - ", " | ", ": " ("Mepo9 — trình dựng video" → "Mepo9"). Người dùng / AI thường nhắc tên ngắn. */
export function tenNganSanPham(ten: string): string {
  const t = ten.trim();
  const m = /^(.{2,}?)\s+[—–|-]\s+\S/.exec(t) ?? /^(.{2,}?):\s+\S/.exec(t);
  return (m?.[1] ?? t).trim();
}

export interface KqDoiSanPham { soDo: SoDo; yeuCau: string; doi: boolean }
/**
 * Đổi tên sản phẩm cũ → mới ở: Giọng điệu, Mục tiêu, Cấm kỵ (doiTenSanPhamTrongSoDo), Mong muốn (yeuCau), "AI đã tự giả định" (giaDinh) và các từ khoá
 * chính là tên sản phẩm cũ (không phân biệt hoa thường). Chữ người dùng tự viết không nhắc tên cũ → giữ nguyên. Không sửa đầu vào.
 */
export function doiSanPhamKhapSoDo(sd: SoDo, yeuCau: string, tenCu: string, tenMoi: string): KqDoiSanPham {
  const cu = tenCu.trim(), moi = tenMoi.trim();
  if (!cu || !moi || cu === moi) return { soDo: sd, yeuCau, doi: false };
  // Thay theo tên đầy đủ trước, rồi theo tên ngắn (nếu khác): "Mepo9 — trình dựng video" → "CapCut — …" và cả chỗ chỉ viết "Mepo9" → "CapCut".
  const cap: [string, string][] = [[cu, moi]];
  const nc = tenNganSanPham(cu), nm = tenNganSanPham(moi);
  if (nc && nm && nc !== nm && (nc !== cu || nm !== moi)) cap.push([nc, nm]);
  let soDo: SoDo = sd;
  let doi = false;
  let yeu = yeuCau;
  for (const [c, m] of cap) {
    const a = doiTenSanPhamTrongSoDo(soDo as SoDo & { giongDieu?: string; camKy?: string[]; mucTieu?: string }, c, m);
    soDo = a.soDo; doi = doi || a.doi;
    yeu = thayTen(yeu, c, m);
  }
  yeu = yeu.slice(0, GIOI_HAN_SO_DO.yeuCau);
  if (yeu !== yeuCau) doi = true;
  if (Array.isArray(soDo.giaDinh)) {
    const gd = soDo.giaDinh.map((x) => cap.reduce((t, [c, m]) => thayTen(t, c, m), x).slice(0, GIOI_HAN_SO_DO.giaDinhMuc));
    if (gd.some((x, i) => x !== soDo.giaDinh![i])) { soDo = { ...soDo, giaDinh: gd }; doi = true; }
  }
  const nut = dsNut(soDo).map((n) => {
    let ts = n.thamSo;
    for (const ten of Object.keys(NHAN_TU_KHOA)) {
      const v = ts?.[ten];
      if (typeof v === "string" && cap.some(([c]) => v.toLocaleLowerCase("vi").includes(c.toLocaleLowerCase("vi")))) {
        const m = cap.reduce((t, [c, mo]) => thayKhongHoa(t, c, mo), v);
        if (m !== v) { ts = { ...ts, [ten]: m }; doi = true; }
      }
    }
    return ts === n.thamSo ? n : { ...n, thamSo: ts };
  });
  soDo = { ...soDo, nut } as unknown as SoDo;
  return { soDo, yeuCau: yeu, doi };
}

/**
 * Đường MÁY CHỦ khi lưu sơ đồ đổi sản phẩm: chỉ thay tên ở những chữ người dùng CHƯA sửa trong lần lưu này (so với bản đang lưu `cu`) — chữ vừa gõ tay giữ nguyên.
 * Trả sơ đồ mới + Mong muốn mới (cột yeu_cau).
 */
export function doiSanPhamNeuChuaSua(cu: SoDo, moi: SoDo, yeuCau: string, tenCu: string, tenMoi: string): KqDoiSanPham {
  const full = doiSanPhamKhapSoDo(moi, yeuCau, tenCu, tenMoi);
  if (!full.doi) return { soDo: moi, yeuCau, doi: false };
  const gU = (a: unknown): string => JSON.stringify(a ?? null);
  const giu = <K extends keyof SoDo>(k: K, ep = false): void => { if (ep || gU(moi[k]) !== gU(cu[k])) (full.soDo as unknown as Record<string, unknown>)[k as string] = moi[k]; };
  // Lời văn (giọng điệu / mục tiêu / cấm kỵ): người gọi sửa BẤT KỲ chữ nào trong ba thứ này cùng lúc → giữ cả ba như họ gửi (hành vi từ 12/10/2026, có test); giả định tách riêng.
  if (gU(moi.giongDieu) !== gU(cu.giongDieu) || gU(moi.mucTieu) !== gU(cu.mucTieu) || gU(moi.camKy) !== gU(cu.camKy)) { giu("giongDieu", true); giu("mucTieu", true); giu("camKy", true); }
  giu("giaDinh");
  const nutCu = new Map(dsNut(cu).map((n) => [n.id, n] as const));
  const nutMoi = new Map(dsNut(moi).map((n) => [n.id, n] as const));
  const nut = dsNut(full.soDo).map((n) => {
    const a = nutCu.get(n.id), b = nutMoi.get(n.id);
    if (!a || !b || gU(a.thamSo) === gU(b.thamSo)) return n; // bước không đổi trong lần lưu này → dùng bản đã thay tên
    return b; // người dùng vừa sửa tham số bước này → giữ nguyên bản người dùng gõ
  });
  (full.soDo as unknown as { nut: Nut[] }).nut = nut;
  return { soDo: full.soDo, yeuCau: full.yeuCau, doi: true };
}

